import React from 'react'

const DashboardHeader = ({ date }) => {
  return (
    <div className="dashboard-header">
        <h1 className="dashboard-title">Dashboard</h1>
        <div className="dashboard-date">{date}</div>
    </div>
  )
}

export default DashboardHeader